import * as yup from 'yup';

function name(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'COMPANY_NAME_IS_REQUIRED',
      defaultMessage: 'Company Name is required',
    }),
  );
}

function accountNumber(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'ACCOUNT_NUMBER_IS_REQUIRED',
      defaultMessage: 'Account Number is required',
    }),
  );
}

function contactFirstName(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'FIRST_NAME_IS_REQUIRED',
      defaultMessage: 'First Name is required',
    }),
  );
}

function contactLastName(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'LAST_NAME_IS_REQUIRED',
      defaultMessage: 'Last Name is required',
    }),
  );
}

function contactEmail(formatMessage) {
  return yup
    .string()
    .email(
      formatMessage({
        id: 'CONTACTEMAIL_FIELD_FORMAT_EMAIL',
        defaultMessage: 'Contact Email must be a valid email address',
      }),
    )
    .required(
      formatMessage({
        id: 'CONTACT_EMAIL_IS_REQUIRED',
        defaultMessage: 'Contact Email is required',
      }),
    );
}

function status(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'STATUS_IS_REQUIRED',
      defaultMessage: 'Status is required',
    }),
  );
}

function fein(formatMessage) {
  return yup
    .string()
    .nullable()
    .max(
      12,
      formatMessage({
        id: 'FEIN_MUST_BE_AT_MOST_12_CHARACTERS',
        defaultMessage: 'FEIN must be at most 12 characters',
      }),
    )
    .test(
      'fein-9-digits',
      formatMessage({
        id: 'FEIN_MUST_BE_EXACTLY_9_DIGITS',
        defaultMessage: 'FEIN must be exactly 9 digits',
      }),
      value => {
        if (!value) return true;
        const digits = value.replace(/-/g, '');
        return /^\d{9}$/.test(digits);
      },
    );
}

function websiteUrl(formatMessage) {
  return yup
    .string()
    .nullable()
    .url(
      formatMessage({
        id: 'WEBSITEURL_FIELD_FORMAT_URL',
        defaultMessage:
          'Website URL must start with http:// or https:// and be a valid URL',
      }),
    )
    .max(
      124,
      formatMessage({
        id: 'WEBSITEURL_FIELD_MAX_LENGTH',
        defaultMessage: 'Website URL must be at most 124 characters',
      }),
    );
}

function bmsSystem(formatMessage) {
  return yup
    .string()
    .nullable()
    .max(
      64,
      formatMessage({
        id: 'BMSSYSTEM_FIELD_MAX_LENGTH',
        defaultMessage: 'BMS System must be at most 64 characters',
      }),
    );
}

function defaultServiceTravelDistance(formatMessage, dispatchPurchased) {
  return yup
    .number()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .nullable()
    .test(
      'required-if-dispatch-purchased',
      formatMessage({
        id: 'DEFAULT_SERVICE_TRAVEL_DISTANCE_IS_REQUIRED',
        defaultMessage: 'Default Service Travel Distance is required',
      }),
      value => {
        if (!dispatchPurchased) return true;
        return value !== null && value > 0;
      },
    );
}

const validationSchema = (formatMessage, getApiUrl, get, dispatchPurchased) =>
  yup
    .object({
      name: name(formatMessage, getApiUrl, get),
      accountNumber: accountNumber(formatMessage, getApiUrl, get),
      contactFirstName: contactFirstName(formatMessage),
      contactLastName: contactLastName(formatMessage),
      contactEmail: contactEmail(formatMessage),
      status: status(formatMessage),
      fein: fein(formatMessage),
      websiteUrl: websiteUrl(formatMessage),
      bmsSystem: bmsSystem(formatMessage),
      defaultServiceTravelDistance: defaultServiceTravelDistance(
        formatMessage,
        dispatchPurchased,
      ),
    })
    .required();

export default validationSchema;
